<template>

	<div fluid style="width: 100%; height: 100%;" width="100%" height="100%">
		
		<v-card tile class="ai-cardPaneScrollTweakAuto elevation-0" :width="leftMenuPaneWidth" height="100%"><!--  -->
			
			<!-- Tree top toolbar -->
			<v-toolbar flat color="toolbarPrimary" :height="toolBarPrimaryHeight" width="100%">
				
				<!-- -------------------------------------------- -->
				<!--   User menu dropown -->
				<!-- -------------------------------------------- -->

				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn  v-on="on" class="ml-n1 pl-1" text small>
							<v-icon class="pr-1">mdi-plus-circle-outline</v-icon>
							Create
						</v-btn>
					</template>

					<v-list dense>
														
						<!-- Create new view template -->
						<v-list-item @click="createViewTemplate">           
							<v-list-item-icon>
								<v-icon>mdi-page-next</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>New view template</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<!-- Create new sorting folder -->
						<v-list-item @click="createSortingFolder">           
							<v-list-item-icon>
								<v-icon>mdi-folder-plus</v-icon>
							</v-list-item-icon>

							<v-list-item-content class="ml-n4">
								<v-list-item-title>Sorting folder</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-menu>

				<v-btn class="ml-n1 pl-1" text small @click="deleteSelectedTreeItem">
					<v-icon class="pr-1">mdi-minus-circle-outline</v-icon>
					Delete
				</v-btn>

			</v-toolbar>
			
			
			<views-editor-tree ref="treeComponent"/>
			
			
		</v-card>

		<v-card :style="`left: ${leftMenuPaneWidth}px;'`" class="brightBackground ai-cardPaneScrollTweak elevation-0" :width="rightContentPaneWidth" tile height="100%">
			<views-editor-tab-menu ref="tabsComponent" />
		</v-card>

	</div>
	
</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import Vue from 'vue';
import fb from '@/shift/fb';
import agile from "@/shift/agile";
import agileFb from "@/shift/agileFb";
import { AiEventBus } from '@/main';
import ViewsEditorTree from "@/components/viewseditor/ViewsEditorTree";
import ViewsEditorTabMenu from "@/components/viewseditor/ViewsEditorTabMenu";
import ViewsSystemSettingsVO from "@/valueobjects/ViewsSystemSettingsVO";


export default
{
	name: "ViewsEditor",
	components: { ViewsEditorTree, ViewsEditorTabMenu },

	// ----------------------------------
	//	Data and properties
	// ----------------------------------

	data: () =>
	({
		leftPaneWidth: 25,
		leftMenuPaneWidth: 50,
		rightContentPaneWidth: 50,
		hasLoadedInitialViewTemplateDocuments: false,
		userJustCreatedDocument: '',
		
		unsubscribeLiveFolders: null,
		unsubscribeLivePageTypes: null,

		boundOnResize: null,

	}),


	computed:
	{
		routeKey()
		{
			return this.$route.params.key;
		},
		
		appBarHeight()
		{
			return agile.appBarHeight();
		},

		toolBarPrimaryHeight()
		{
			return agile.toolBarPrimaryHeight();
		},

		toolBarSecondaryHeight()
		{
			return agile.toolBarSecondaryHeight();
		}
	},


	// ----------------------------------
	//	VUE: Watcher
	// ----------------------------------

	watch:
	{
		
	},


	// ----------------------------------
	//	VUE: Created and mounted
	// ----------------------------------

	created()
	{
		
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);

		this.initializeTreeContentLiveListener();

		AiEventBus.$on('authenticationComplete', this.syncUserStateFromFirestore);
		this.syncUserStateFromFirestore();


	},

	mounted()
	{
		this.onResize();
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		// --------------------------------------------------------------------
		//
		//	On resize function for the 'left' and 'right' panes
		//
		// --------------------------------------------------------------------

		onResize()
		{
			
			// Todo: Oh my god boring coding
			if (window.innerWidth < 600)
			{
				this.isMiniDrawer = true;
				this.leftMenuPaneWidth = 56;	//xs
			}
			else if (window.innerWidth < 960)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 260;	//sm
			}
			else if (window.innerWidth < 1264)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 280;	//md
			}
			else if (window.innerWidth < 1904)
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 300;	//lg
			}
			else
			{
				this.isMiniDrawer = false;
				this.leftMenuPaneWidth = 320;	//xl
			}
			
			this.rightContentPaneWidth = window.innerWidth-this.leftMenuPaneWidth;
			
		},
		


		// ----------------------------------
		//	Sync user
		// ----------------------------------
		
		syncUserStateFromFirestore()
		{
			// Get folder open/closed state for user since last session
			if (agile.loggedInUser.uid)
			{
				fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(this.routeKey).get()
				.then((doc) =>
				{
					if (doc.exists)
					{
						const docData = doc.data();

						
						// NB: It will throw error the first time a user is visiting this page, since no states are saved.
						// Therefore we use try catch here, because error checking all thes properties are boring.

						// Sync open nodes in tree
						try {
							this.$refs.treeComponent.treeOpenNodes = docData.viewsEditorTreeState;
						} catch (er) { console.log(er)/**/ }
						
						this.$refs.treeComponent.hasInitializedUserSync = true;
						


						// Sync open documents in tab
						try {
							this.$refs.tabsComponent.syncInitialTabs(
								docData.viewsEditorActiveTab,
								docData.viewsEditorOpenTabs
							);
						} catch (er) { console.log(er)/**/ }
						this.$refs.tabsComponent.hasInitializedUserSync = true;


					}
					else
					{
						// We failed, but we still ned top open these props, so we can save new. #Todo: I guess no good coding here :s
						this.$refs.treeComponent.hasInitializedUserSync = true;
						this.$refs.tabsComponent.hasInitializedUserSync = true;

						// doc.data() will be undefined in this case
						console.log("syncUserStateFromFirestore(): No such document!");
					}
				})
				.catch((error) =>
				{
					console.log('Error getting user document:', error.message);
				});

			}
		},



		

		// ----------------------------------
		//	Delete items in tree
		// ----------------------------------

		deleteSelectedTreeItem()
		{	
			var activeItem = this.$refs.treeComponent.treeActiveItem[0];

			// ----------------------------------
			//	Do some cheking before we start to delete
			// ----------------------------------

			if (!activeItem)
			{
				//this.$root.$alert('No item', 'No selected item to delete');
				return;
			}

			
			this.$root.$confirm('Deleting', 'Do you really want to delete this item (and possible nested folders and fields)?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					
					// ----------------------------------
					//	Batch possible nested nodes
					// ----------------------------------

					const folderCollection = agileFb.getDevQueryStart(this.routeKey, 'views-editor-sorting-folders');
					const pageTypeCollection = agileFb.getDevQueryStart(this.routeKey, 'view-templates');

					// #Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
					const batch = fb.db.batch();
					
					// Get item and mark it for deletion
					const itemToDelete = agile.getObjectById(this.$refs.treeComponent.treeItems, activeItem);
					

					if (itemToDelete === null)
					{
						this.$root.$alert('Error', 'Item marked for deletion is null for some reason');
					}
					else
					{
						const useCol = (itemToDelete.nodeType === 'folder') ? folderCollection : pageTypeCollection ;
						batch.delete(useCol.doc(itemToDelete.id));

						// Go through all the possible children as well
						agile.recursivelyAddFirestoreBatchDeletes(pageTypeCollection, folderCollection, itemToDelete.children, batch);
						

						// ----------------------------------
						//	Do the deletion
						// ----------------------------------

						batch.commit()
						.then(() =>
						{
							this.$root.ai_app.snackbarText = 'Deleted item(s)';
							this.$root.ai_app.snackbarTimeout = 4000;
							this.$root.ai_app.snackbar = true;
						})
						.catch((error) =>
						{
							this.$root.$alert("Error", error.message);
						});
					}
				}
			});
		},
		

		// --------------------------------------------------------------------
		//
		//	Create new sorting folder
		//
		// --------------------------------------------------------------------

		createSortingFolder()
		{
			this.$root.$setName('Name of sorting folder') // Open dialog box to set name
			.then((nameReturned) =>
			{
				if (nameReturned)
				{
					//for (let i = 0; i < 100; i++) // STRESS TEST
					//{
					// Setup command
					const collection = fb.db
						.collection('dev-collection')
						.doc('dev-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('views-editor-sorting-folders');

					const selectedTreeNodeId = this.$refs.treeComponent.treeActiveItem[0]; // is undefined if nothing is selected in tree

					// Find selected parent item
					let parentNodeId = (selectedTreeNodeId) ? selectedTreeNodeId : 'root' ;
					let positionInTree;

					// Get the order position
					if (selectedTreeNodeId) 
					{
						const selectedItem = agile.getObjectById(this.$refs.treeComponent.treeItems, selectedTreeNodeId);
						
						if (selectedItem && selectedItem.children) // If we have selected a *folder* in the tree, then the 'children' object will exist.
						{
							positionInTree = selectedItem.children.length;
						}
						else
						{
							//this.$root.$alert("Warning", 'You can only add new view items to folders or the root. Your new view item is added to the root instead.');
							positionInTree = this.$refs.treeComponent.treeItems.length;
							parentNodeId = 'root';
							//return; // Abort further operations
						}
					}
					else
					{
						positionInTree = this.$refs.treeComponent.treeItems.length;
					}
					
					collection.add(
					{
						name: nameReturned,//+" "+i,
						metaData:
						{
							treeParent: parentNodeId,
							treePosition: positionInTree,
						},
					})
					.then((docRef) =>
					{
						docRef;
						//console.log("Document written with ID: ", docRef.id);
					})
					.catch((error) =>
					{
						console.log('Error creating sorting folder:', error.message);
					});
					//}//////////////////
				}
			});
		},


		// --------------------------------------------------------------------
		//
		//	Create new page type
		//
		// --------------------------------------------------------------------
		
		createViewTemplate()
		{
			this.$root.$setName('Name of page type') // Open dialog box to set name
			.then((nameReturned) =>
			{
				if (nameReturned)
				{
					// We store this property, so when we receive the new doucment from
					// firestore later, we can open the new document in the tab menu
					this.userJustCreatedDocument = nameReturned;

					// Setup command
					const collection = fb.db
						.collection('dev-collection')
						.doc('dev-doc')
						.collection(this.routeKey)
						.doc(this.routeKey)
						.collection('view-templates');

					const selectedTreeNodeId = this.$refs.treeComponent.treeActiveItem[0]; // is undefined if nothing is selected in tree

					// Find selected parent item
					let parentNodeId = (selectedTreeNodeId) ? selectedTreeNodeId : 'root' ;
					let positionInTree;

					// Get the order position
					if (selectedTreeNodeId) 
					{
						const selectedItem = agile.getObjectById(this.$refs.treeComponent.treeItems, selectedTreeNodeId);
						
						if (selectedItem && selectedItem.children) // If we have selected a *folder* in the tree, then the 'children' object will exist.
						{
							positionInTree = selectedItem.children.length;
						}
						else
						{
							//this.$root.$alert("Warning", 'You can only add new view items to folders or the root. Your new view item is added to the root instead.');
							positionInTree = this.$refs.treeComponent.treeItems.length;
							parentNodeId = 'root';
							//return; // Abort further operations
						}
					}
					else
					{
						positionInTree = this.$refs.treeComponent.treeItems.length;
					}


					collection.add(
					{
						// --------------------------------------------------------------------
						//	IMPORTANT
						//	Creation of the basic view template data object here!!!
						//
						// --------------------------------------------------------------------

						name: nameReturned,
						metaData:
						{
							treeParent: parentNodeId,
							treePosition: positionInTree,
						},
						settings: agile.convertPropertiesToPlainObject(new ViewsSystemSettingsVO()),
						groups: Vue.observable([]),
						
					})
					.then((docRef) =>
					{
						docRef;
						//console.log("Page type written with ID: ", docRef.id);
					})
					.catch((error) =>
					{
						console.log('Error creating sorting folder:', error.message);
					});
				}
			});
		},



		// ----------------------------------
		//	Get data for the tree, and let
		//	it keep load changes live.
		// ----------------------------------

		initializeTreeContentLiveListener()
		{
			// Reset tree before we start live listeners

			if (this.$refs.treeComponent) this.$refs.treeComponent.treeItems = [];


			// --------------------------------------------------------------------
			//
			//	Connection for sorting folder data
			//
			// --------------------------------------------------------------------
			
			const collection = fb.db
				.collection('dev-collection')
				.doc('dev-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('views-editor-sorting-folders');


			// Gogogo, go live
			this.unsubscribeLiveFolders = collection.onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						// Build tree structure
						const docData = change.doc.data();
						docData.id = change.doc.id;
						docData.nodeType = 'folder';
						docData.children = [];

						this.$refs.treeComponent.insertInTree(docData);

					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						const docData = change.doc.data();
						docData.id = change.doc.id;

						

						this.$refs.treeComponent.updateTreeItem(docData);
						this.$refs.tabsComponent.updateTabItem(docData);
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						agile.getAndRemoveObjectById(this.$refs.treeComponent.treeItems, change.doc.id); // This will remove the object from treeItems

						// Update tree
						// We need to tick one before we go go
						setTimeout(this.$refs.treeComponent.updateTreeDrag, 1);
					}
				});

				
			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			});
			

			// --------------------------------------------------------------------
			//
			//	Connection for view templates
			//
			// --------------------------------------------------------------------
			
			const pageTypeCollection = fb.db
				.collection('dev-collection')
				.doc('dev-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('view-templates');


			// Gogogo, go live
			this.unsubscribeLivePageTypes = pageTypeCollection.onSnapshot(res =>
			{
				const changes = res.docChanges();
				
				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						// Build tree structure
						const docData = change.doc.data();
						docData.id = change.doc.id;
						docData.nodeType = 'page';

						this.$refs.treeComponent.insertInTree(docData);
						
						// When a user has just made a new document!
						if (this.hasLoadedInitialViewTemplateDocuments && this.userJustCreatedDocument === docData.name)
						{
							// Open new made item in tab menu
							this.$refs.tabsComponent.openViewEditorWithLiveListener(change.doc.id);
							
							// Open parent folder of thew new document if closed
							const newDocParent = agile.getObjectParentIdByChildId(this.$refs.treeComponent.treeItems, change.doc.id);

							if (!this.$refs.treeComponent.treeOpenNodes.includes(newDocParent))
							{
								this.$refs.treeComponent.treeOpenNodes.push(newDocParent);
							}

							// Reset
							this.userJustCreatedDocument = '';
						}
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						const docData = change.doc.data();
						docData.id = change.doc.id;
						this.$refs.treeComponent.updateTreeItem(docData);
						this.$refs.tabsComponent.updateTabItem(docData);
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						agile.getAndRemoveObjectById(this.$refs.treeComponent.treeItems, change.doc.id); // This will remove the object from treeItems
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(this.$refs.treeComponent.updateTreeDrag, 1);
					}
				});

				// On the first response from firestore, all documents are shipped to us.
				// Now we can set this for convenience
				this.hasLoadedInitialViewTemplateDocuments = true;

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			});


		},




		
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);

		// Close down live listeners
		//console.log("* Unsubscribing live listeners for page types");
		this.unsubscribeLiveFolders();
		this.unsubscribeLivePageTypes();

		AiEventBus.$off('authenticationComplete', this.syncUserStateFromFirestore);
	},

};
</script>
